export const getOrdinal = (n) => {
  if (parseFloat(n) === parseInt(n) && !isNaN(n)) {
    var s = ['th', 'st', 'nd', 'rd'],
      v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }
  return n;
};
